import Axios from "axios";
import constant from "../constant";
import api from "../api";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  GET_VENDOR: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_VENDOR()
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  DELETE_ACCOUNT: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.delete(
          constant.BASE_URL + api.Vendor.DELETE_ACCOUNT()
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  SET_ONLINE_STATUS: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.SET_ONLINE_STATUS(),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  GET_DRIVER: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_DRIVER()
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  ADD_DRIVER: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.Vendor.ADD_DRIVER(),data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  // Records that the partner tapped "Say Hi on WhatsApp"
  WHATSAPP_CONNECT: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.Vendor.WHATSAPP_CONNECT()
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  UPDATE_VENDOR: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.UPDATE_VENDOR(),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  UPDATE_DRIVER: (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.UPDATE_DRIVER(id),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  ADD_VENDOR_SUBSCRIPTION: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.Vendor.ADD_VENDOR_SUBSCRIPTION(),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_ALL_VENDOR_SUBSCRIPTIONS: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_ALL_VENDOR_SUBSCRIPTIONS()
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_VENDOR_SUBSCRIPTION_BY_ID: (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_VENDOR_SUBSCRIPTION_BY_ID(id)
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  UPDATE_VENDOR_SUBSCRIPTION: (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.UPDATE_VENDOR_SUBSCRIPTION(id),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  DELETE_VENDOR_SUBSCRIPTION: (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.delete(
          constant.BASE_URL + api.Vendor.DELETE_VENDOR_SUBSCRIPTION(id)
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  ACTIVATE_VENDOR_SUBSCRIPTION: (id, payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.ACTIVATE_VENDOR_SUBSCRIPTION(id),
          payload || {}
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_SYSTEM_CONFIG_BY_KEY: (key) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_SYSTEM_CONFIG_BY_KEY(key)
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_ONE_WAY_ELIGIBILITY: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_ONE_WAY_ELIGIBILITY()
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  CREATE_ONE_WAY_AVAILABILITY: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.Vendor.CREATE_ONE_WAY_AVAILABILITY(),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_MY_ONE_WAY_BOOKINGS: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(constant.BASE_URL + api.Vendor.GET_MY_ONE_WAY_BOOKINGS());
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  GET_ONE_WAY_STATS: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(constant.BASE_URL + api.Vendor.GET_ONE_WAY_STATS());
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  GET_ALL_ONE_WAY_AVAILABILITIES: (params) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_ALL_ONE_WAY_AVAILABILITIES(),
          { params }
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_ONE_WAY_AVAILABILITY_BY_ID: (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_ONE_WAY_AVAILABILITY_BY_ID(id)
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  UPDATE_ONE_WAY_AVAILABILITY: (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.UPDATE_ONE_WAY_AVAILABILITY(id),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  DELETE_ONE_WAY_AVAILABILITY: (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.delete(
          constant.BASE_URL + api.Vendor.DELETE_ONE_WAY_AVAILABILITY(id)
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  TOGGLE_ONE_WAY_AVAILABILITY_ACTIVATION: (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Vendor.TOGGLE_ONE_WAY_AVAILABILITY_ACTIVATION(id),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },

  GET_INQUIRIES_BY_AVAILABILITY_ID: (id, params) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Vendor.GET_INQUIRIES_BY_AVAILABILITY_ID(id),
          { params }
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },


};
